<h2 mat-dialog-title>{{ isEditMode ? 'Edit User' : 'Add New User' }}</h2>

<mat-dialog-content [formGroup]="userForm">
  <mat-form-field appearance="fill" class="w-full">
    <mat-label>Full Name</mat-label>
    <input matInput formControlName="fullName" />
  </mat-form-field>

  <mat-form-field appearance="fill" class="w-full">
    <mat-label>Email</mat-label>
    <input matInput type="email" formControlName="email" />
  </mat-form-field>

  <mat-form-field appearance="fill" class="w-full">
    <mat-label>{{ isEditMode ? 'New Password (optional)' : 'Password' }}</mat-label>
    <input matInput type="password" formControlName="password" />
    <mat-hint *ngIf="isEditMode">Leave blank to keep current password.</mat-hint>
  </mat-form-field>

  <!-- ✅ Dynamic Role Dropdown -->
  <mat-form-field appearance="fill" class="w-full">
    <mat-label>Role</mat-label>
    <mat-select formControlName="role">
      <mat-option *ngFor="let role of roles" [value]="role.name">
        {{ role.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onCancel()" [disabled]="loading">
    Cancel
  </button>
  <button mat-flat-button color="primary" (click)="onSave()" [disabled]="loading">
    {{ isEditMode ? 'Update' : 'Save' }}
  </button>
</mat-dialog-actions>

<!-- Loader Overlay -->
<div class="loader-overlay" *ngIf="loading">
  <mat-spinner></mat-spinner>
</div>
